import React from 'react';
import { BrandColor } from '@Shared.Angular/@types/brandColor';

export type CardProps = {
  iconClass: string;
  title: string;
  description: string;
  actionText?: string;
  color?: BrandColor;
  isDisabled?: boolean;
  onClick: () => void;
};

export const Card = ({
  iconClass,
  title,
  description,
  actionText,
  color,
  isDisabled,
  onClick
}: CardProps) => {
  const colorModifier = color ? ` card-container--${color}` : '';

  return (
    <div
      className={`card-container${colorModifier} hover-shadow ${
        isDisabled ? 'card-container--disabled' : ''
      }`}
      onClick={isDisabled ? undefined : onClick}
      aria-disabled={isDisabled}
      role="button"
      data-testid={`card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="card-container__icon-wrapper">
        <i className={`fa-light ${iconClass} card-container__icon`} />
      </div>
      <span className="card-container__title">{title}</span>
      <p className="card-container__description">{description}</p>
      {actionText && (
        <span className="card-container__action-link">
          {actionText}{' '}
          <span className="fa-light fa-arrow-right card-container__action-arrow"></span>
        </span>
      )}
    </div>
  );
};
